import type { DateIntentKey } from "@shared/seo";
import type { DateFilterType } from "@/components/FiltersPanel";

export interface FilterRoutePaths {
  /** /regions/troy on a town page */
  regionPath: string | null;
  /** /categories/music on a category page */
  categoryPath: string | null;
  /** The date a date page stands for: "today" on /today */
  dateIntent: DateIntentKey | null;
  /** /today, /tomorrow or /this-weekend */
  dateIntentPath: string | null;
}

/**
 * The page a filtered list's address is built on, and the date that page already stands for
 * (left out of the query string). A date page (/today, /regions/troy/this-weekend) keeps its
 * address only while its own date is chosen. With another date or none, the list moves to the
 * page without the date part (/ or /regions/troy), so a reload or a shared link shows the same
 * events.
 */
export function getFilterUrlBase(
  route: FilterRoutePaths,
  dateFilter: DateFilterType,
): { basePath: string; baseDateIntent: DateIntentKey | null } {
  if (route.dateIntent && route.dateIntentPath && dateFilter === route.dateIntent) {
    return {
      basePath: route.regionPath ? `${route.regionPath}${route.dateIntentPath}` : route.dateIntentPath,
      baseDateIntent: route.dateIntent,
    };
  }
  return { basePath: route.regionPath ?? route.categoryPath ?? "/", baseDateIntent: null };
}
